import React from 'react';

const AudioToggle = ({ className, onClick }) => (
  <button className={className} onClick={onClick}>
    <svg viewBox="1334 727 25 25" xmlns="http://www.w3.org/2000/svg">
      <title>Toggle Audio</title>
      <defs>
        <mask id="b" x="0" y="0" width="25" height="25" fill="currentColor">
          <use xlinkHref="#a" />
        </mask>
      </defs>
      <g stroke="currentColor" transform="translate(1334 727)" fillRule="evenodd">
        <use mask="url(#b)" strokeWidth="2" xlinkHref="#a" />
        <path strokeLinecap="square" fill="none" d="M16.156 19.312l-4.208-3.156H7.74V9.844h4.208l4.208-3.156z" />
        <path className="audio-toggle__mute" d="M21.182 4.818L4.818 21.182" />
      </g>
    </svg>
  </button>
);

export default AudioToggle;



/** WEBPACK FOOTER **
 ** ./src/js/components/audio-toggle.js
 **/